import { Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import OrderDetailsSection from '../OrderDetailsSection';

import styles from './styles.module.scss';

export const FiberOneTimeFee = () => {
  const { t } = useTranslation('ChangePlan');

  return (
    <OrderDetailsSection id="fiber-one-time-fee" title={t('fiber.oneTimeFee.title')}>
      <div className={styles['fiber-one-time-fee']}>
        <Txt component="span" variant="bodySmallRegular">
          {t('fiber.oneTimeFee.descriptionRegular')}
        </Txt>
        <Txt component="span" variant="bodySmallBold">
          {t('fiber.oneTimeFee.descriptionBold')}
        </Txt>
      </div>
    </OrderDetailsSection>
  );
};
